import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { IDay } from './types.js';

export const ForecastData = ({ day: { skiFieldModelData } }: { day: IDay }) => {
  if (!skiFieldModelData) {
    return null;
  }

  const { heading, maxTemp, minTemp, totalRain, totalSnow, windStatement, fzlStatement } = skiFieldModelData;
  // icon="snow-dark" icon="freezing-level-dark"
  return (
    <div className="u-mT-sm u-bT-1">
      <h3 className="h2 u-mB-0">{heading}</h3>

      <div className="Grid">
        <Data icon="temp-high" label="high" val={`${maxTemp}°`} />
        <Data icon="temp-low" label="low" val={`${minTemp}°`} />
        <Data icon="snow" label="total snow" val={`${totalSnow}cm`} classes="svg-fill-textSlate" />
        <Data icon="rainfall" label="total rainfall" val={`${totalRain}mm`} />
        <Data icon="wind" label="wind at top" val={windStatement} />
        <Data icon="freezing-level" label="freezing level" val={fzlStatement} classes="svg-fill-textSlate" />
      </div>
    </div>
  );
};

const Data = ({ icon, label, val, classes }: { icon: IconNameV1; label: string; val: string; classes?: string }) => (
  <div className="Grid-cell u-md-width1of3 u-sm-width1of1 u-pT-sm">
    <IconWithText icon={icon} classes={classes}>
      <h4 className="u-mT-0 u-mB-0">{label}</h4>
      <p className="small u-mT-0 u-mB-0">{val}</p>
    </IconWithText>
  </div>
);
